import { useTranslation } from "react-i18next";

import Button from "../input/Button";

function FilterClearButtonLayout ( props ) {

    const { t } = useTranslation();

    return <Button {...props}>{t("common.clear")}</Button>;

}

export default FilterClearButtonLayout;

